// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@asgardeo/auth-react";
import AvatarMenu from "./AvatarMenu";
import '../../styles/Header.css'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';

const AppBar = styled(MuiAppBar, {
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
}));

export default function Header() {
  const { state } = useAuthContext();
  const navigate = useNavigate();
  const navigateHome = () => { navigate('/support'); }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="sticky">
        <nav className="navbar">
          <div className="container-fluid top-nav-bar">
            <a className="navbar-brand">
              <img src="/pulse-white.png" alt="Wso2 Logo" height="50" className="d-inline-block mr-4 pointer pe-3" onClick={navigateHome} />
              Support Portal Lite
            </a>
            {state.isAuthenticated ?
              <AvatarMenu />
              : <></>
            }
          </div>
        </nav>
      </AppBar>
    </Box>
  );
}
